import { CheckOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import TabToolbar from '../../../components/styled/TabToolbar';
import { useTranslation } from '../../../../../../i18n/useTranslation';

type DescriptionEditorToolbarProps = {
    disableSave: boolean;
    onClose: () => void;
    onSave: () => void;
};

export const DescriptionEditorToolbar = ({ disableSave, onClose, onSave }: DescriptionEditorToolbarProps) => {
    const { t } = useTranslation();
    return (
        <TabToolbar className="mt-2">
            <Button className="mr-2" type="default" onClick={onClose}>
                {t('Back')}
            </Button>
            <Button
                data-testid="description-editor-save-button"
                onClick={onSave}
                disabled={disableSave}
                aria-label={t('Save')}
            >
                <CheckOutlined /> {t('Save')}
            </Button>
        </TabToolbar>
    );
};
